import React from 'react';
import { Box, Text } from '@rsos/components/capstone/base';

const EmptyState = () => {
  return (
    <Box my="5px" align="center" justify="center">
      <Box width="370px" flow={10} align="center">
        <Text size="normal" color="heavyWarning">
          Only one jurisdictional boundary can exist per ECC.
        </Text>
        <Text size="normal" textAlign="center" inline color="secondaryText">
          We accept [zipped] folders composed of the following types:{' '}
          <Text inline fontWeight="bold">
            .shp, .shx, .dbf, .prj., .GeoJSON, .KML
          </Text>
        </Text>
      </Box>
    </Box>
  );
};

export default EmptyState;
